import "./validation";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { createRouter, createWebHistory } from "vue-router";
import "@fontsource-variable/dm-sans";
import "./styles/main.scss";
import App from "./App.vue";
import Home from "./pages/Home.vue";
import Dataset from "./pages/Dataset.vue";
import NewDataset from "./pages/NewDataset.vue";
import Inbox from "./pages/Inbox.vue";
import Form from "./pages/Form.vue";
import Connections from "./pages/Connections.vue";
import Connect from "./pages/Connect.vue";
import PublicDashboard from "./pages/PublicDashboard.vue";
import PublicView from "./pages/PublicView.vue";
import Approval from "./pages/Approval.vue";
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: Home },
    {
      path: "/shared/:org/:token",
      component: PublicView,
      meta: { public: true },
    },
    {
      path: "/shared/dashboards/:org/:token",
      component: PublicDashboard,
      meta: { public: true },
    },
    { path: "/new", component: NewDataset },
    { path: "/datasets/:id", component: Dataset },
    { path: "/inbox", component: Inbox },
    { path: "/forms/:id", component: Form },
    { path: "/connections", component: Connections },
    { path: "/connect", component: Connect },
    { path: "/approvals/:id", component: Approval },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});
createApp(App).use(createPinia()).use(router).mount("#app");
